interface HeliosAgendaSource {
  agendaId?: string;
  id?: string;
  systemType: string;
}

export interface ModuleLike {
  agendas: HeliosAgendaSource[];
  childs?: ModuleLike[];
}

export const getHeliosAgendaIds = (modules: ModuleLike[] = []): string[] =>
  modules.flatMap((module) => [
    ...module.agendas
      .filter((agenda) => agenda.systemType === 'Helios')
      .map((agenda) => agenda.agendaId ?? agenda.id ?? '')
      .filter(Boolean),
    ...(module.childs ? getHeliosAgendaIds(module.childs) : []),
  ]);
